<template>
  <card-list
    title="Transaksi Terhapus"
    data-url="/api/v1/sale/deleted"
    data-size="10"
    :dataHeaders="tHeaders"
  />
</template>
<script>
import CardList from "../../components/CardList";
export default {
  components: {
    CardList
  },
  data () {
    return {
      tHeaders: [
        { faktur: "Faktur", align: 'left' },
        { invoice: "Invoice", align: 'left' },
        { customer_name: "Customer", align: 'left' },
        { delete_reason: "Delete Reason", align: 'left' },
        { deleted_at: "Deleted At", align: 'left' },
      ]
    }
  }
};
</script>